module.exports = __webpack_public_path__ + "static/img/8.cb9aa12a.jpg";